//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Header";
//Install
import Footer from "../../../Footer";
//Install
import M597I5 from "../../../../Media/Image/029.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Pano İmalatı : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik Taahhüt, Endüstriyel Tesislerden Konutlara, Hastanelerden Okullara ve Alışveriş Merkezlerine Kadar Farklı Yapı Tiplerine Uygun Özel ve Standart Panoların Tasarım, Üretim ve Montajını Gerçekleştirmektedir."
        //Element
        let URL = "https://temaselektrik.com/sunulan-hizmetler/pano-imalati"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Pano İmalatı"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Pano ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "İmalat "
                                        ),
                                        //Element
                                        "Hizmetleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Taahhüt Endüstriyel Tesislerden Konutlara, Hastanelerden Okullara ve Alışveriş Merkezlerine Kadar Farklı Yapı Tiplerine Uygun Özel ve Standart Panoların Tasarım, Üretim ve Montajını Gerçekleştirmektedir.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Uluslararası Mühendislik Standartları ve Teknik Ekibimizle, Yüksek Kalite, Güvenlik ve Uzun Ömürlü Performans Odaklı Panolar Üretilmektedir. Üretim Sürecinde Kullanılan Tüm Sistemler Uluslararası Kalite Standartlarına Uygun Şekilde Seçilmektedir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Projelerinize Özel Pano Çözümleri :"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. A.G. Ana Dağıtım ve Tali Dağıtım Panoları"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Kumanda ve Otomasyon Panoları"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. Harmonik Filtreli Kompanzasyon Panoları"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Kompanzasyon Panoları"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "5. Jeneratör Şebeke Transfer Panoları"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "6. Y.G. Kontrol Panoları"
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Pano İmalatı", title: "Pano İmalatı", src: M597I5, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;